export default "__VITE_ASSET__a040c31c__"